
// Vision UI Dashboard React layouts
import Markets from "layouts/dashboard";

import Profile from "layouts/profile";

// Vision UI Dashboard React icons
import { IoAddCircle } from "react-icons/io5";
import { BsFillPersonFill } from "react-icons/bs";
import { IoHome } from "react-icons/io5";
import MarketData from "layouts/marketdata";
import MarketCreate from "layouts/market_create";
import AdminDashboard from "layouts/AdminDashboard";

const routes = [
  
  {
    type: "collapse",
    name: "Markets",
    key: "markets",
    route: "/markets",
    icon: <IoHome size="15px" color="inherit" />,
    component: Markets,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Create Market",
    key: "marketcreate",
    route: "/market_create",
    icon: <IoAddCircle size="15px" color="inherit" />,
    component: MarketCreate,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "My Profile",
    key: "profile",
    route: "/profile",
    icon: <BsFillPersonFill size="15px" color="inherit" />,
    component: Profile,
    noCollapse: true,
  },
  {
    type: "hidden",
    name: "Market View",
    key: "marketdata",
    route: `/marketdata/:id`,
    icon: <IoHome size="15px" color="inherit" />,
    component: MarketData,
    noCollapse: true,
  },
  {
    type: "hidden",
    name: "Admin View",
    key: "admin",
    route: `/admin`,
    icon: <IoHome size="15px" color="inherit" />,
    component: AdminDashboard,
    noCollapse: true,
  },
];

export default routes;
